import history from './history';

export const callbackOnlyInMainPage = (callback: () => void) => {
    if (['/', '/lite', '/trader'].includes(history.location.pathname)) callback();
};
